export const TOOLBAR_CONFIG = {
  height: {
    default: 60,
    compact: 55,
  },
  container: {
    paddingX: {
      default: 2,
      compact: 2,
    },
  },
  actionGroup: {
    gap: {
      default: 4,
      compact: 2,
    },
    invisibleDividerMargin: {
      default: 2,
      compact: 2,
    },
  },
  button: {
    padding: {
      default: 2,
      compact: 2,
    },
    iconTextGap: {
      default: 1,
      compact: 1,
    },
    textSize: {
      default: "xs",
      compact: "xs",
    },
  },
  divider: {
    height: {
      default: "40px",
      compact: "40px",
    },
  },
  zoom: {
    buttonPaddingX: {
      default: 2,
      compact: 1,
    },
    textWidth: {
      default: "40px",
      compact: "35px",
    },
    textSize: {
      default: "sm",
      compact: "xs",
    },
    iconTextSpacing: {
      default: 1,
      compact: 0,
    },
  },
} as const

export default TOOLBAR_CONFIG
